export class ColumnRequest{
    columnsId?: number;
    constructor(columnsId:number){
        this.columnsId = columnsId;
    }
}